import React, { useState } from "react";

/**
 * Props:
 * - value (number | string)
 * - onChange (number) => void
 * - name
 * - placeholder
 * - className
 */

const formatWithCommas = (value) => {
  if (value === "" || value === null || value === undefined) return "";

  const parts = String(value).split(".");
  const integerPart = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  const decimalPart = parts[1] ? `.${parts[1]}` : "";

  return integerPart + decimalPart;
};

const cleanValue = (value) => {
  return value.replace(/[^\d.]/g, "");
};

export default function FormattedNumberInput({
  value,
  onChange,
  name,
  placeholder = "",
  className = "",
}) {
  const [displayValue, setDisplayValue] = useState(formatWithCommas(value));

  const handleChange = (e) => {
    const raw = cleanValue(e.target.value);

    setDisplayValue(formatWithCommas(raw));

    if (onChange) {
      onChange(raw);
    }
  };

  const handleBlur = () => {
    setDisplayValue(formatWithCommas(value));
  };

  const handleFocus = () => {
    // remove commas while editing
    setDisplayValue(String(value || ""));
  };

  return (
    <input
      type="text"
      name={name}
      value={displayValue}
      onChange={handleChange}
      onBlur={handleBlur}
      onFocus={handleFocus}
      placeholder={placeholder}
      className={className}
      inputMode="decimal"
      autoComplete="off"
    />
  );
}
